"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueue = void 0;
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        this.qSize = 101;
        this.sendables = [];
    }
    /**
     * method adds the log event (sendable) to the queue and then it will get sent using the transport.
     * @param sendable sendable object
     */
    EventQueue.prototype.add = function (sendable) {
        if (this.sendables.length > this.qSize) {
            console.warn('Queue size exceded');
            return;
        }
        this.sendables.push(sendable);
    };
    /**
     * returns front sendable from the sendables queue
     * @returns ISendable
     */
    EventQueue.prototype.next = function () {
        return this.sendables[0];
    };
    /**
     * returs true if sendable present in queue
     * @returns boolean
     */
    EventQueue.prototype.hasNext = function () {
        return !!this.sendables[0];
    };
    /**
     * method remove the sendable event from the queue if any exist.
     */
    EventQueue.prototype.remove = function () {
        var sendable = this.sendables[0];
        if (sendable) {
            this.sendables.shift();
        }
    };
    /**
     * this method update queue size
     * @param size
     */
    EventQueue.prototype.setSize = function (size) {
        this.qSize = size;
    };
    return EventQueue;
}());
exports.EventQueue = EventQueue;
